"use client";

import Logo from "./Logo";
import Notice from "./Notice";
import Button from "./Button";
import { worldAdminScreen } from "../worlds/registry";

/** 選ばれた世界のマスターデータ管理 UI を出す */
export default function WorldAdminScreen({ world, onBack }: { world: string; onBack: () => void }) {
  const Screen = worldAdminScreen(world);

  if (Screen) {
    return <Screen onBack={onBack} />;
  }

  return (
    <div className="panel">
      <Logo />
      <Notice>
        <p>{world} のマスターデータ管理 UI は未実装です。</p>
      </Notice>
      <div className="foot">
        <Button onClick={onBack} inline>
          戻る
        </Button>
      </div>
    </div>
  );
}
